import BaseService from "./BaseService";
import { toast } from 'react-toastify';


const saveReviewHistory = (reviewObj) => {
    //Call backend code to savew review history for approval or rejection of Issuer Update
    var obj = {
            msgId: null,
            sysId: null,
            opr: "postReviewHistory",
            hdrStruct: null,
            queryParam: null,
            reqData: {
               "adminReviewHistory": reviewObj,
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Review history creation was successful!");

                }

            });
    
  }

const AdminService = {
    saveReviewHistory
};


export default AdminService;